import { render, staticRenderFns } from "./sendOffer.vue?vue&type=template&id=b60df956"
import script from "./sendOffer.vue?vue&type=script&lang=js"
export * from "./sendOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports